interface SquidSymbolProps {
  size?: number;
}

export function SquidSymbol({ size = 24 }: SquidSymbolProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <ellipse cx="12" cy="8.5" rx="4.5" ry="5" fill="currentColor" />
      <path
        d="M8.5 12.5c-1.2 1.8-2 3.8-2 5.5 0 .8.6 1.5 1.4 1.5.6 0 1.1-.4 1.3-1 .5-1.3 1-2.5 1.8-3.5M15.5 12.5c1.2 1.8 2 3.8 2 5.5 0 .8-.6 1.5-1.4 1.5-.6 0-1.1-.4-1.3-1-.5-1.3-1-2.5-1.8-3.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10 13.5c-.8 1.5-1.2 3-1.2 4.5M12 14c0 2 .2 3.5.8 4.8M14 13.5c.8 1.5 1.2 3 1.2 4.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <circle cx="10" cy="7.5" r="0.85" fill="#0f1115" />
      <circle cx="14" cy="7.5" r="0.85" fill="#0f1115" />
    </svg>
  );
}
